import { render } from "./IconCalendar.vue.js?vue&type=template&id=5251c70c!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconCalendar.vue?vue&type=template&id=5251c70c"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__